import React, { useEffect, useState,useContext } from "react";
import { trackPromise } from "react-promise-tracker";
import apis from '../../services/apis';
import './feature.css'; 
import { toast } from 'react-toastify';

import { getTaskList } from "../../helper/context/actions";
import { useSmarkDispatch } from "../../Context/KeycloakContext";
import AppContext from "../../Context/AppContext";

const FeatureList = (props) => {
    const dispatch = useSmarkDispatch();
    const [featureList, setFeatureList] = useState([]);
    const storedToken = localStorage.getItem("keycloakToken");
    const { applicationId, siteId } = useContext(AppContext);

    useEffect(() => {
        if (props.header_data) {
            // ✅ FIX: clear old data immediately
            setFeatureList([]);
            loadFeatureList();
        }
    }, [props.header_data]);

    const loadFeatureList = async () => {
        if (!props.header_data) return;

        const { masterProjectId, masterReleaseId } = props.header_data;

        // ✅ FIX: always clear before API call
        setFeatureList([]);

        if (masterProjectId && masterReleaseId) {
            trackPromise(
                apis.getFeatureListHB(applicationId, siteId,masterProjectId, masterReleaseId, storedToken)
                    .then((response) => {
                        if (response?.json) {
                            const parsed = JSON.parse(response.json);
                            setFeatureList(parsed.featurelist || []);
                        } else {
                            setFeatureList([]);
                        }
                    })
                    .catch(() => setFeatureList([]))
            );
            return;
        }

        if (masterProjectId) {
            trackPromise(
                apis.getAllFeaturesByProject(applicationId, siteId,masterProjectId, storedToken)
                    .then((response) => {
                        if (response?.json) {
                            const parsed = JSON.parse(response.json);
                            setFeatureList(parsed.featuresList || []);
                        } else {
                            setFeatureList([]);
                        }
                    })
                    .catch(() => setFeatureList([]))
            );
        }
    };

    const editFeature = async (featureId) => {
        if (!featureId) return;

        try {
            const response = await apis.getFeatureById(applicationId, siteId,featureId, storedToken);
            if (response?.json) {
                props.editFeature(true, response, props.header_data, 'edit');
            }
        } catch (e) {
            console.error(e);
        }
    };

    const showFeatureTasks = (featureId) => {
        let data = {
            masterProjectId: props.header_data.masterProjectId || 0,
            masterReleaseId: props.header_data.masterReleaseId || 0,
            masterUserId: props.header_data.masterUserId || 0,
            masterFeatureId: featureId || 0,
            userStoryId: 0,
            filterStartDate: props.header_data.filterStartDate,
            filterEndDate: props.header_data.filterEndDate
        };

        trackPromise(
            getTaskList(dispatch, applicationId, siteId,data, storedToken)
                .then((response) => {
                    if (response?.taskDetails?.length > 0) {
                        toast.success('Task list fetched successfully!');
                        props.hideFeatureList(false, featureId, props.header_data, 'showTask');
                    } else {
                        toast.warning('No record found!');
                    }
                })
                .catch(console.error)
        );
    };

    return (
        <div className="form-sec shadow-lg add-form-sec-left">
            <div className="form-blog w-100 float-left position-relative">
                <span onClick={() => props.hideFeatureList(false)} className="close-form-icon">
                    <i className="fa fa-times" />
                </span>

                <h2>Feature List</h2>

                <div className="w-100 float-left pl-2 pr-2" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                    {featureList.length === 0 ? (
                        <p className="text-center">No record found!</p>
                    ) : (
                        featureList.map((feature) => (
                            <div
                                key={feature.featureId}
                                className="w-100 float-left block storyBox shadow-sm"
                                style={{ backgroundColor: feature.colorCode }}
                            >
                                <div className="block-box w-100 float-left">
                                    <div className="heading-tp-left">
                                        <span>{feature.title}</span>
                                    </div>

                                    <div className="assignee my-1">
                                        <button
                                            onClick={() => editFeature(feature.featureId)}
                                            className="btn btn-sm btn-light border-dark mr-1"
                                        >
                                            <small>Edit</small>
                                        </button>
                                        <button
                                            onClick={() => showFeatureTasks(feature.featureId)}
                                            className="btn btn-sm btn-light border-dark"
                                        >
                                            <small>Show Task</small>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default FeatureList;
